export default function() {
  'ngInject';
  return {
    restrict: 'A',
    scope: {
      loggedIn: '='
    },
    template:
      '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()" ng-if="loggedIn"><i class="fa fa-bars"></i></a>',
    controller: function($scope, $element, $timeout) {
      'ngInject';
      if (!$scope.loggedIn) {
        $('body').addClass('mini-navbar');
      }

      $scope.minimalize = function() {
        $('body').toggleClass('mini-navbar');
        if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
          // Hide menu in order to smoothly turn on when maximize menu
          $('#side-menu').hide();
          // For smoothly turn on menu
          $timeout(function() {
            $('#side-menu').fadeIn(400);
          }, 200);
        } else if ($('body').hasClass('fixed-sidebar')) {
          $('#side-menu').hide();
          $timeout(function() {
            $('#side-menu').fadeIn(400);
          }, 100);
        } else {
          // Remove all inline style from jquery fadeIn function to reset menu state
          $('#side-menu').removeAttr('style');
        }
      };
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/minimalizaSidebar/index.js